import React from 'react';
import { Box, Typography } from '@mui/material';
import HTMLContent from './content-blocks/HTMLContent';
import ValidatedInput from './content-blocks/ValidatedInput';

export default function Problem({ problem, inputLabel, validAnswers, tip, answerLength, questionKey, number }) {
  const promptId = `${questionKey}-problem`;
  return <Box component="section" className="worksheet-question" sx={{ py: 2.5, borderTop: 1, borderColor: 'divider' }}>
    <Typography variant="h4" component="h4" sx={{ mb: 1 }}>Question {number}</Typography>
    <Box id={promptId} sx={{ mb: 1.5, maxWidth: '65ch' }}><HTMLContent content={problem} /></Box>
    <ValidatedInput questionKey={questionKey} field={inputLabel} validAnswers={validAnswers} tip={tip} answerLength={answerLength} directionsId={promptId} />
  </Box>;
}
